var ro = {
	"neptune.Button.loadingAriaLabel": "se încarcă",
	"neptune.Chips.ariaLabel": "Șterge {choice}",
	"neptune.ClearButton.ariaLabel": "Elimină",
	"neptune.CloseButton.ariaLabel": "Închide",
	"neptune.DateInput.day.label": "Zi",
	"neptune.DateInput.day.placeholder": "ZZ",
	"neptune.DateInput.month.label": "Lună",
	"neptune.DateInput.year.label": "An",
	"neptune.DateInput.year.placeholder": "AAAA",
	"neptune.DateLookup.day": "zi",
	"neptune.DateLookup.goTo20YearView": "Accesează vizualizarea pe 20 de ani",
	"neptune.DateLookup.month": "lună",
	"neptune.DateLookup.next": "înainte",
	"neptune.DateLookup.previous": "înapoi",
	"neptune.DateLookup.selected": "selectată",
	"neptune.DateLookup.twentyYears": "20 de ani",
	"neptune.DateLookup.year": "an",
	"neptune.FlowNavigation.back": "înapoi la pasul anterior",
	"neptune.Info.ariaLabel": "Mai multe informații",
	"neptune.Label.optional": "(Opțional)",
	"neptune.Link.opensInNewTab": "(se deschide într-o filă nouă)",
	"neptune.MoneyInput.Select.placeholder": "Selectează o opţiune...",
	"neptune.MoneyInput.Select.selectCurrencyLabel": "Selectează moneda",
	"neptune.PhoneNumberInput.SelectInput.placeholder": "Selectează o opțiune...",
	"neptune.Select.searchPlaceholder": "Caută...",
	"neptune.SelectInput.noResultsFound": "Nu s-a găsit niciun rezultat",
	"neptune.SelectOption.action.label": "Alege",
	"neptune.SelectOption.selected.action.label": "Schimbă opțiunea aleasă",
	"neptune.StatusIcon.iconLabel.error": "Eroare:",
	"neptune.StatusIcon.iconLabel.information": "Informații:",
	"neptune.StatusIcon.iconLabel.pending": "În așteptare:",
	"neptune.StatusIcon.iconLabel.success": "Gata:",
	"neptune.StatusIcon.iconLabel.warning": "Avertisment:",
	"neptune.Summary.statusDone": "Finalizat",
	"neptune.Summary.statusNotDone": "De făcut",
	"neptune.Summary.statusPending": "În așteptare",
	"neptune.Table.actionHeader": "Acțiune",
	"neptune.Table.emptyData": "Nu s-a găsit niciun rezultat",
	"neptune.Table.loaded": "Datele din tabel au fost încărcate",
	"neptune.Table.loading": "Datele din tabel se încarcă",
	"neptune.Table.refreshPage": "Reîncarcă pagina",
	"neptune.Upload.csButtonText": "Încarci un alt fișier?",
	"neptune.Upload.csFailureText": "Încărcare eșuată. Te rugăm să încerci din nou",
	"neptune.Upload.csSuccessText": "Încărcare completă!",
	"neptune.Upload.csTooLargeMessage": "Te rugăm să furnizezi un fișier mai mic de {maxSize} MB",
	"neptune.Upload.csWrongTypeMessage": "Tipul de fișier nu a fost acceptat. Te rugăm să încerci din nou cu un alt fișier",
	"neptune.Upload.psButtonText": "Anulează",
	"neptune.Upload.psProcessingText": "Se încarcă...",
	"neptune.Upload.retry": "Încearcă din nou",
	"neptune.Upload.usButtonText": "Sau selectează un fișier",
	"neptune.Upload.usDropMessage": "Atașează fișierul pentru a începe încărcarea",
	"neptune.Upload.usPlaceholder": "Glisează și atașează un fișier mai mic de {maxSize} MB",
	"neptune.UploadButton.allFileTypes": "Toate tipurile de fișiere",
	"neptune.UploadButton.dropFiles": "Trage fișierul pentru a începe încărcarea",
	"neptune.UploadButton.instructions": "{fileTypes}, de maximum {size}MB",
	"neptune.UploadButton.maximumFiles": "Maximum {maxFiles} fișiere.",
	"neptune.UploadButton.uploadFile": "Încarcă fișier",
	"neptune.UploadButton.uploadFiles": "Încarcă fișiere",
	"neptune.UploadInput.deleteModalBody": "Eliminarea acestui fișier îl va șterge din sistemul nostru.",
	"neptune.UploadInput.deleteModalCancelButtonText": "Anulare",
	"neptune.UploadInput.deleteModalConfirmButtonText": "Elimină",
	"neptune.UploadInput.deleteModalTitle": "Sigur vrei să elimini acest fișier?",
	"neptune.UploadInput.fileIsTooLarge": "Fișierul este prea mare",
	"neptune.UploadInput.fileTypeNotSupported": "Tipul fișierului nu este acceptat",
	"neptune.UploadInput.maximumFilesAlreadyUploaded": "Ne pare rău, această încărcare nu a reușit, deoarece putem accepta doar {maxFilesAllowed} fișiere simultan.",
	"neptune.UploadItem.deleting": "Se șterge...",
	"neptune.UploadItem.removeFile": "Elimină fișierul {filename}",
	"neptune.UploadItem.uploaded": "Încărcat",
	"neptune.UploadItem.uploadedFile": "Fișier încărcat",
	"neptune.UploadItem.uploading": "Se încarcă...",
	"neptune.UploadItem.uploadingFailed": "Încărcare eșuată"
};

export { ro as default };
//# sourceMappingURL=ro.json.mjs.map
